import React from 'react';
import ReactDOM from 'react-dom';

import {AppRoot} from '../components/AppRoot';
import Login from '../page/login/LogIn';

const App = () => (
    <AppRoot>
        <Login />
    </AppRoot>
);

ReactDOM.render(<App />, document.querySelector('main'));
